export default __webpack_public_path__ + "static/media/pr.efd2d572.svg";